
import FETCHING from '../../library/fetching'
import UMUM from '../../library/umum'
import DATAMASTER from '../../library/dataMaster'

export default {
  name: 'RealisasiKeuangan',
  computed: {
    currentInstansiName() {
      const id = this.filterku.instansi;
      if (!id) return 'SEMUA UNIT KERJA';
      const match = (this.$store.state.list_instansi || []).find(i => i.id == id);
      return match ? match.instansi : '-';
    }
  },
  data() {
    return {
      monev_pembangunan: null,
      tahunList: Array.from({ length: 2030 - 2012 + 1 }, (_, i) => 2012 + i),
      form: {
        id: '',
        uraian: '',
        jenis_kegiatan: '',
        pagu_anggaran: 0,
        nilai_kontrak: 0,
        nomor_kontrak: '',
        tgl_mulai: '',
        tgl_berakhir: '',
        yy: '',
        sumber_dana: '',
        instansi: '',
        unit_kerja: '',
        keterangan: '',
        realisasi_fisik: null,
        realisasi_keuangan: 0,
        dd: '',
        mm: ''
      },
      editForm: {
        id: '',
        uraian: '',
        jenis_kegiatan: '',
        pagu_anggaran: 0,
        nilai_kontrak: 0,
        nomor_kontrak: '',
        tgl_mulai: '',
        tgl_berakhir: '',
        yy: '',
        sumber_dana: '',
        unit_kerja: '',
        keterangan: '',
        realisasi_fisik: null,
        realisasi_keuangan: 0,
        dd: '',
        mm: ''
      },

      jml_pagu: 0,
      jml_nilaikontrak: 0,
      jml_realisasifisik: 0,
      jml_realisasikeuangan: 0,
      jml_realisasipersen: 0,

      filterku: {
        program_kode: '',
        tahun: '',
        unit_kerja: '',
        instansi: '',
      },

      list_data: [],

      page_first: 1,
      page_last: 0,
      page_limit: 8,
      cari_value: "",
      cek_load_data: true,

      mdl_add: false,
      mdl_edit: false,
      mdl_hapus: false,
      selectedHapus: null,
      btn_add: false,
      btn_save: false,
      FETCHING: FETCHING,
      UMUM: UMUM,
      DATAMASTER: DATAMASTER,
    }
  },
  methods: {
    getView() {
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.CT_REALISASI_FISIK_KEUANGAN + "view", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
        },
        body: JSON.stringify({
          data_ke: this.page_first,
          cari_value: this.cari_value,
          page_limit: this.page_limit,
          instansi: this.filterku.instansi,
          unit_kerja: this.filterku.unit_kerja,
          tahun: this.filterku.tahun,
        })
      })
        .then(res => res.json())
        .then(res_data => {
          this.list_data = res_data.data || [];
          this.page_last = res_data.jml_data || 1;

          this.jml_pagu = typeof res_data.jml_pagu !== 'undefined' ? res_data.jml_pagu : 0;
          this.jml_nilaikontrak = typeof res_data.jml_nilaikontrak !== 'undefined' ? res_data.jml_nilaikontrak : 0;
          this.jml_realisasifisik = typeof res_data.jml_realisasifisik !== 'undefined' ? res_data.jml_realisasifisik : 0;
          this.jml_realisasikeuangan = typeof res_data.jml_realisasikeuangan !== 'undefined' ? res_data.jml_realisasikeuangan : 0;
          this.jml_realisasipersen = typeof res_data.jml_realisasipersen !== 'undefined' ? res_data.jml_realisasipersen : 0;

          this.$store.commit("hideLoading");
        }).catch(err => {
          console.error('getView error', err);
          this.$store.commit("hideLoading");
        });
    },

    formatTanggalPrint() {
      const months = ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'];
      const d = new Date();
      return `${d.getDate()} ${months[d.getMonth()]} ${d.getFullYear()}`;
    },
    formatWaktuPrint() {
      const d = new Date();
      let h = d.getHours();
      let m = d.getMinutes();
      if (h < 10) h = '0' + h;
      if (m < 10) m = '0' + m;
      return `${h}.${m}`;
    },
    cetakPDFDetail() {
      const tanggal = this.formatTanggalPrint();
      const waktu = this.formatWaktuPrint();
      const tahun = this.filterku.tahun || new Date().getFullYear();
      const namaOpd = this.currentInstansiName || 'SEMUA UNIT KERJA';

      // Build table rows grouped by jenis_kegiatan
      let rowsHtml = '';
      let lastJenis = null;
      let counter = 0;

      this.list_data.forEach(data => {
        // Group header
        if (data.jenis_kegiatan !== lastJenis) {
          lastJenis = data.jenis_kegiatan;
          rowsHtml += `<tr style="background-color:#e8eaf6;font-weight:bold;">
            <td></td>
            <td colspan="11" style="text-transform:uppercase;padding:5px 8px;border:1px solid #000;">${data.jenis_kegiatan || '-'}</td>
          </tr>`;
        }

        counter++;
        const styleFisik = (data.realisasi_fisik !== null && data.realisasi_fisik < 100) ? 'color:#c00000' : (data.realisasi_fisik == 100 ? 'color:#375623;font-weight:bold' : '');
        const stylePersen = (data.realisasi_persen !== null && data.realisasi_persen < 100) ? 'color:#c00000' : (data.realisasi_persen == 100 ? 'color:#375623;font-weight:bold' : '');
        const keterangan = (data.realisasi_persen == 100) ? 'Selesai' : 'Belum Selesai';

        rowsHtml += `<tr>
          <td style="text-align:center;border:1px solid #000;padding:4px;">${counter}.</td>
          <td style="border:1px solid #000;padding:4px;">${data.uraian || ''}</td>
          <td style="text-align:right;border:1px solid #000;padding:4px;">Rp. ${this.UMUM.Rupiah(data.pagu_anggaran || 0)}</td>
          <td style="text-align:right;border:1px solid #000;padding:4px;">Rp. ${this.UMUM.Rupiah(data.nilai_kontrak || 0)}</td>
          <td style="border:1px solid #000;padding:4px;">${data.nomor_kontrak || '-'}</td>
          <td style="text-align:center;border:1px solid #000;padding:4px;">${data.tgl_mulai ? this.UMUM.tglConvert(data.tgl_mulai) : '-'}</td>
          <td style="text-align:center;border:1px solid #000;padding:4px;">${data.tgl_berakhir ? this.UMUM.tglConvert(data.tgl_berakhir) : '-'}</td>
          <td style="text-align:center;border:1px solid #000;padding:4px;${styleFisik}">${data.realisasi_fisik !== null && data.realisasi_fisik !== undefined ? data.realisasi_fisik + '%' : '-'}</td>
          <td style="text-align:right;border:1px solid #000;padding:4px;">Rp. ${this.UMUM.Rupiah(data.realisasi_keuangan || 0)}</td>
          <td style="text-align:center;border:1px solid #000;padding:4px;${stylePersen}">${data.realisasi_persen !== null && data.realisasi_persen !== undefined ? data.realisasi_persen + '%' : '-'}</td>
          <td style="text-align:center;border:1px solid #000;padding:4px;">${data.sumber_dana || '-'}</td>
          <td style="text-align:center;border:1px solid #000;padding:4px;">${keterangan}</td>
        </tr>`;
      });

      // JUMLAH row
      rowsHtml += `<tr style="background-color:#d9d9d9;font-weight:bold;">
        <td colspan="2" style="text-align:center;border:1px solid #000;padding:5px;">JUMLAH</td>
        <td style="text-align:right;border:1px solid #000;padding:4px;">Rp. ${this.UMUM.Rupiah(this.jml_pagu || 0)}</td>
        <td style="text-align:right;border:1px solid #000;padding:4px;">Rp. ${this.UMUM.Rupiah(this.jml_nilaikontrak || 0)}</td>
        <td style="border:1px solid #000;padding:4px;"></td>
        <td style="border:1px solid #000;padding:4px;"></td>
        <td style="border:1px solid #000;padding:4px;"></td>
        <td style="text-align:center;border:1px solid #000;padding:4px;">${this.jml_realisasifisik}%</td>
        <td style="text-align:right;border:1px solid #000;padding:4px;">Rp. ${this.UMUM.Rupiah(this.jml_realisasikeuangan || 0)}</td>
        <td style="text-align:center;border:1px solid #000;padding:4px;">${this.jml_realisasipersen}%</td>
        <td style="border:1px solid #000;padding:4px;"></td>
        <td style="border:1px solid #000;padding:4px;"></td>
      </tr>`;

      const htmlContent = `
        <!DOCTYPE html>
        <html>
        <head>
          <meta charset="UTF-8">
          <title>Laporan Realisasi Fisik dan Keuangan - ${namaOpd} - ${tahun}</title>
          <style>
            @page { size: landscape; margin: 10mm; }
            body { font-family: Arial, sans-serif; font-size: 8.5pt; color: #000; background: white; }
            h3 { text-align: center; margin: 0; padding: 2px 0; font-size: 11pt; }
            .opd-name { text-align: center; font-size: 11pt; font-weight: bold; margin: 6px 0 2px 0; text-decoration: underline; }
            .tanggal { font-weight: bold; font-style: italic; background-color: yellow; display: inline-block; padding: 3px 6px; margin: 10px 0 6px 0; font-size: 9.5pt; }
            table { width: 100%; border-collapse: collapse; margin-top: 6px; }
            th { border: 1px solid #000; padding: 5px 4px; text-align: center; background-color: #d9d9d9; font-size: 8.5pt; }
            td { border: 1px solid #000; padding: 4px; font-size: 8.5pt; }
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          </style>
        </head>
        <body>
          <h3>LAPORAN REALISASI FISIK DAN KEUANGAN</h3>
          <h3>JENIS PENGADAAN : KONSTRUKSI, KONSULTANSI, BARANG DAN JASA LAINNYA</h3>
          <h3>TAHUN ANGGARAN ${tahun}</h3>
          <div class="opd-name">${namaOpd.toUpperCase()}</div>
          <div class="tanggal">Tanggal ${tanggal}, Pukul ${waktu} WITA</div>
          <table>
            <thead>
              <tr>
                <th rowspan="2" width="3%">No</th>
                <th rowspan="2" width="24%">Jenis Kegiatan / Uraian</th>
                <th rowspan="2" width="10%">Pagu Anggaran (Rp)</th>
                <th rowspan="2" width="10%">Nilai Kontrak (Rp)</th>
                <th rowspan="2" width="10%">Nomor Kontrak</th>
                <th colspan="2" width="12%">Tanggal Kontrak</th>
                <th colspan="3">Realisasi</th>
                <th rowspan="2" width="6%">Sumber Dana</th>
                <th rowspan="2" width="6%">Keterangan</th>
              </tr>
              <tr>
                <th width="6%">Mulai</th>
                <th width="6%">Selesai</th>
                <th width="5%">Fisik (%)</th>
                <th width="10%">Keuangan (Rp)</th>
                <th width="4%">%</th>
              </tr>
              <tr style="background-color:#fff2cc;font-weight:bold;">
                <td></td>
                <td colspan="11" style="text-align:left;padding:5px 8px;">${namaOpd.toUpperCase()}</td>
              </tr>
            </thead>
            <tbody>
              ${rowsHtml}
            </tbody>
          </table>
          <script>
            window.onload = function() { window.print(); }
          <\/script>
        </body>
        </html>
      `;

      const printWindow = window.open('', '_blank', 'width=1200,height=750');
      printWindow.document.write(htmlContent);
      printWindow.document.close();
    },

    openEdit(data) {
      this.editForm = {
        id: data.id,
        uraian: data.uraian || '',
        jenis_kegiatan: data.jenis_kegiatan || '',
        pagu_anggaran: data.pagu_anggaran || 0,
        nilai_kontrak: data.nilai_kontrak || 0,
        nomor_kontrak: data.nomor_kontrak || '',
        tgl_mulai: this.fmtDateToYMD(data.tgl_mulai),
        tgl_berakhir: this.fmtDateToYMD(data.tgl_berakhir),
        yy: data.yy || '',
        sumber_dana: data.sumber_dana || '',
        unit_kerja: data.unit_kerja || '',
        keterangan: data.keterangan || '',
        realisasi_fisik: data.realisasi_fisik,
        realisasi_keuangan: data.realisasi_keuangan || 0,
        dd: data.dd || '',
        mm: data.mm || ''
      };
      this.mdl_edit = true;
    },

    saveEdit() {
      if (!this.editForm.id) {
        this.Notify('ID data tidak ditemukan', 'negative', 'warning');
        return;
      }

      this.btn_save = true;
      const payload = {
        id: this.editForm.id,
        uraian: this.editForm.uraian,
        jenis_kegiatan: this.editForm.jenis_kegiatan,
        pagu_anggaran: Number(this.editForm.pagu_anggaran) || 0,
        nilai_kontrak: Number(this.editForm.nilai_kontrak) || 0,
        nomor_kontrak: this.editForm.nomor_kontrak,
        tgl_mulai: this.fmtDateToYMD(this.editForm.tgl_mulai),
        tgl_berakhir: this.fmtDateToYMD(this.editForm.tgl_berakhir),
        yy: this.editForm.yy,
        sumber_dana: this.editForm.sumber_dana,
        unit_kerja: this.editForm.unit_kerja,
        keterangan: this.editForm.keterangan,
        realisasi_fisik: this.editForm.realisasi_fisik,
        realisasi_keuangan: Number(this.editForm.realisasi_keuangan) || 0,
        dd: this.editForm.dd,
        mm: this.editForm.mm,
      };

      fetch(this.$store.state.url.CT_REALISASI_FISIK_KEUANGAN + "editData", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: 'kikensbatara ' + localStorage.token
        },
        body: JSON.stringify(payload)
      }).then(res => res.json()).then((res_json) => {
        this.btn_save = false;
        this.Notify('Sukses menyimpan perubahan', 'primary', 'check_circle_outline');
        this.mdl_edit = false;
        this.getView();
      }).catch(err => {
        this.btn_save = false;
        console.error('saveEdit error', err);
        this.Notify('Gagal menyimpan perubahan', 'negative', 'warning');
      });
    },

    removeData() {
      if (!this.selectedHapus) return;
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.CT_REALISASI_FISIK_KEUANGAN + "removeData", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
        },
        body: JSON.stringify({ id: this.selectedHapus.id })
      })
        .then(res => res.json())
        .then(() => {
          this.$store.commit("hideLoading");
          this.Notify('Data berhasil dihapus', 'negative', 'check_circle_outline');
          this.selectedHapus = null;
          this.getView();
        })
        .catch(err => {
          this.$store.commit("hideLoading");
          console.error('removeData error', err);
          this.Notify('Gagal menghapus data', 'negative', 'warning');
        });
    },

    fmtDateToYMD(dateValue) {
      if (!dateValue && dateValue !== 0) return null;
      if (typeof dateValue === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(dateValue)) return dateValue;
      const d = new Date(dateValue);
      if (isNaN(d.getTime())) return null;
      const yyyy = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      const dd = String(d.getDate()).padStart(2, '0');
      return `${yyyy}-${mm}-${dd}`;
    },

    onTglMulaiChange() {
      if (this.form.tgl_mulai) {
        const d = new Date(this.form.tgl_mulai);
        if (!isNaN(d.getTime())) {
          if (!this.form.dd) this.form.dd = d.getDate();
          if (!this.form.mm) this.form.mm = d.getMonth() + 1;
          if (!this.form.yy) this.form.yy = d.getFullYear();
        }
      }
    },

    async openAdd() {
      try {
        if (typeof DATAMASTER.getInstansiAsync === 'function') {
          await DATAMASTER.getInstansiAsync('');
        }
        const profilex = JSON.parse(localStorage.profile || '{}');
        const profile = profilex.profile || {};

        this.form = {
          id: '',
          uraian: '',
          jenis_kegiatan: '',
          pagu_anggaran: 0,
          nilai_kontrak: 0,
          nomor_kontrak: '',
          tgl_mulai: '',
          tgl_berakhir: '',
          yy: this.filterku.tahun || '',
          sumber_dana: '',
          instansi: profile.instansi_id || '',
          unit_kerja: '',
          keterangan: '',
          realisasi_fisik: null,
          realisasi_keuangan: 0,
          dd: '', mm: ''
        };

        if (typeof DATAMASTER.getUnitKerjaAsync === 'function') {
          const list = await DATAMASTER.getUnitKerjaAsync(this.form.instansi || '');
          if (profile.unit_kerja) {
            const match = (list || []).find(u => u.id === profile.unit_kerja);
            this.form.unit_kerja = match ? profile.unit_kerja : (list && list.length ? list[0].id : '');
          } else if (list && list.length) {
            this.form.unit_kerja = list[0].id;
          }
        }
        this.mdl_add = true;
      } catch (e) {
        console.error('openAdd error', e);
        this.mdl_add = true;
      }
    },

    async onChangexUnitKerjaForm() {
      try {
        const list = await DATAMASTER.getUnitKerjaAsync(this.form.instansi);
        if (list && list.length && !this.form.unit_kerja) {
          this.form.unit_kerja = list[0].id;
        }
        return list;
      } catch (err) {
        console.error('getUnitKerjaAsync error', err);
        return [];
      }
    },

    addData() {
      this.btn_add = true;
      const payload = {
        uraian: this.form.uraian,
        jenis_kegiatan: this.form.jenis_kegiatan,
        pagu_anggaran: Number(this.form.pagu_anggaran) || 0,
        nilai_kontrak: Number(this.form.nilai_kontrak) || 0,
        nomor_kontrak: this.form.nomor_kontrak,
        tgl_mulai: this.fmtDateToYMD(this.form.tgl_mulai),
        tgl_berakhir: this.fmtDateToYMD(this.form.tgl_berakhir),
        yy: this.form.yy,
        sumber_dana: this.form.sumber_dana,
        unit_kerja: this.form.unit_kerja,
        keterangan: this.form.keterangan,
        realisasi_fisik: this.form.realisasi_fisik,
        realisasi_keuangan: Number(this.form.realisasi_keuangan) || 0,
        dd: this.form.dd, mm: this.form.mm
      };

      fetch(this.$store.state.url.CT_REALISASI_FISIK_KEUANGAN + "addData", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: 'kikensbatara ' + localStorage.token
        },
        body: JSON.stringify(payload)
      }).then(res => res.json()).then(res_json => {
        this.btn_add = false;
        this.Notify('Sukses Menambah Data', 'primary', 'check_circle_outline');
        this.mdl_add = false;
        this.getView();
      }).catch(err => {
        this.btn_add = false;
        console.error('addData error', err);
        this.Notify('Gagal menambah data', 'negative', 'warning');
      });
    },

    // helper / pagination
    Notify(message, positive, icon) {
      this.$q.notify({
        message: message,
        color: positive,
        icon: icon,
        position: 'top',
        timeout: 800,
      })
    },

    cari_data() {
      this.page_first = 1;
      this.getView();
    },

    indexing(index) {
      var idx = ((this.page_first - 1) * this.page_limit) + index
      return idx
    },

    async onChangexInstansi() {
      // pastikan list_instansi ter-load dulu
      await DATAMASTER.getInstansiAsync("");
      await this.onChangexUnitKerjaLocal(); // pakai local yang sudah ada
    },

    async onChangexUnitKerja() {
      // tetapkan ulang unit list (jangan auto pilih kecuali hanya 1)
      const unitkerjax = await DATAMASTER.getUnitKerjaAsync(this.filterku.instansi);
      // jangan paksa pilih, biarkan '' = Semua
      this.filterku.unit_kerja = '';
      // optional: jika cuma 1 unit tersedia, auto set (sama seperti data_pembangunan)
      if (unitkerjax && unitkerjax.length === 1) {
        this.filterku.unit_kerja = unitkerjax[0].id;
      }
      this.getView();
    },
    async onChangexUnitKerjaLocal() {
      var unitkerjax = await DATAMASTER.getUnitKerjaAsync(this.filterku.instansi)
      if (unitkerjax && unitkerjax.length > 0) {
        this.filterku.unit_kerja = unitkerjax[0].id
      } else {
        this.filterku.unit_kerja = ''
      }
      this.getView();
    },

    btn_prev() {
      if (this.page_first > 1) {
        this.page_first--
        this.getView();
      }
    },
    btn_next() {
      if (this.page_first < this.page_last) {
        this.page_first++
        this.getView();
      }
    },

  },

  async mounted() {
    let profilex = JSON.parse(localStorage.profile || '{}');
    let profile = profilex.profile || {};
    this.filterku.instansi = profile.instansi_id || '';
    this.filterku.unit_kerja = profile.unit_kerja || '';

    this.monev_pembangunan = profile.monev_pembangunan ? Number(profile.monev_pembangunan) : null;

    const d = new Date();
    this.filterku.tahun = d.getFullYear();

    await DATAMASTER.getInstansiAsync('');
    DATAMASTER.getMasterPermintaan();
    DATAMASTER.getTahun();

    // Load sub-unit kerja list based on current instansi without resetting the filter
    if (this.filterku.instansi) {
      await DATAMASTER.getUnitKerjaAsync(this.filterku.instansi);
    }

    this.getView();
  },
}
